export const listOfUiForCertificates = {
    inEligible: "Eligible",
    overDue: "overDue",
    verificationPending: "verificationPending",
    examPending: "examPending",
    extendDuration: "extendDuration",
    nocVerificationPending: "nocVerificationPending",
    ready: "ready",
    claimed: "claimed",
    dispatch: "dispatch",
    deliveryConfrimedAt: "deliveryConfrimedAt",
    na: "na"
} as const

export const certificateStatus = {
    claimed: "claimed",
    ready: "ready",
    dispatch: "dispatch",
    delivered: "delivered"
} as const